module.exports = __webpack_public_path__ + "img/时尚热点ico.c75cdb79.png";